import { render } from "./ProductSalesMargin.vue?vue&type=template&id=38cac9d0"
import script from "./ProductSalesMargin.vue?vue&type=script&lang=js"
export * from "./ProductSalesMargin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/Sales/ProductSalesMargin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38cac9d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38cac9d0', __exports__)) {
    api.reload('38cac9d0', __exports__)
  }
  
  module.hot.accept("./ProductSalesMargin.vue?vue&type=template&id=38cac9d0", () => {
    api.rerender('38cac9d0', render)
  })

}


export default __exports__